export const translationsDic = {
  sr: {
    languange: 'sr',
    values: {
      lblCreateReservation: 'Kreiranje rezervacije',
      lblProfile: 'Profil',
      lblReservations: 'Rezervacije',
      lblInstructors: 'Instruktori',
      lblUsers: 'Korisnici',
      lblShedule: 'Raspored',
      lblPriceListLessons: 'Cenovnik obuka',
      lblPriceListGearRent: 'Cenovnik najam opreme',
      lblLogout: 'Odjava',
      lblConfirm: 'Potvrdi',
      lblCancel: 'Otkaži',
      lblCompany: 'Kompanija',
      lblFieldOfWork: 'Delatnost',
      lblAddress: 'Adresa',
      lblMatBr: 'Matični broj',
      lblPib: 'Pib',
      lblWebAddress: 'Web adresa',
      lblContactNumer: 'Kontakt telefon',
      lblContactEmail: 'Kontakt email',
      msgCreateReservation: 'Rezervacije će biti obrađene u najkraćem mogućem roku nakon čega ćete dobiti potvrdu na Vaš email',
      msgProfile: 'Pregledajte i izmenite Vaše kontakt podatke',
      btnCreateReseravtionTxt: 'Rezervacija',
      lblView: 'Pregled',
      msgViewReservations: 'Pregledajte kreiranje rezervacije',
      msgViewInstructors: 'Pregled i editovanje instruktora',
      msgViewSchedule: 'Pregledajte Vaš raspored',
      lblFrom: 'Od',
      lblTo: 'Do',
      lblEnterNextUser: 'Unesite narednog korisnika',
      lblAcceptTermsAndConditions: 'Slažem se sa',
      lblWithTermsAndConditions: 'Uslovima korišćenja',
      lblTermsAndConditions: 'Uslovi korišćenja',
      lblReserve: 'Rezerviši',
      lblEnterUser: 'Unesite korisnika',
      lblName: 'Ime',
      lblLastName: 'Prezime',
      lblAge: 'Godine',
      lblSport: 'Sport',
      lblSki: 'Skijanje',
      lblSnowboard: 'Snowboard',
      lblSkillLevel: 'Nivo znanja skijanja',
      lblSkillLevelBasic: 'Osnovni',
      lblSkillLevelIntermediate: 'Srednji',
      lblSkillLevelExpert: 'Napredni',
      lblSnowboardSkillLevel: 'Nivo znanja snowboarda',
      msgChooseInstructor: 'Izaberite željenog instruktora (Napomena: Odnosi se na individualnu nastavu)',
      // tslint:disable-next-line: max-line-length
      msgChooseInstructorNote: 'Napomena: željeni instruktor mozda neće biti dostupan u izabranom terminu. U tom slučaju, biće dodeljen od strane administratora.',
      lblLessonType: 'Vrsta nastave',
      lblInidivdual: 'Individualna',
      lblGroup2: 'Grupna 2 časa',
      lblGroup4: 'Grupna 4 časa',
      lblDaily: 'Izaberite broj časova dnevno',
      lblGearAndMeal: 'Izaberite da li želite obrok i/ili ski opremu',
      lblMeal: 'Obrok',
      lblGear: 'Komplet ski oprema',
      lblDelete: 'Obriši',
      lblLogin: 'Prijava',
      lblRegister: 'Registracija',
      lblUserName: 'Korisničko ime',
      lblPassword: 'Lozinka',
      lblEnterPassword: 'Molimo Vas unesite lozinku',
      lblEnterUsername: 'Molimo Vas unesite korisničko ime',
      lblPleaseLoginToContinue: 'Molimo Vas prijavite se',
      lblRegisterToContinue: 'Molimo Vas registrujte se da biste nastavili',
      lblPhone: 'Telefon',
      lblEmail: 'Email',
      lblConfirmPassword: 'Potvrdite lozinku',
      lblUserRole: 'Tip korisnika',
      lblRegisterEnterName: 'Molimo Vas unesite Ime',
      lblRegisterEnterLastName: 'Molimo Vas unesite Prezime',
      lblRegisterEnterEmail: 'Molimo Vas unesite Email',
      lblRegisterEnterPhone: 'Molimo Vas unesite Telefon',
      lblRegisterEnterUserName: 'Molimo Vas unesite Korisničko ime',
      lblRegisterEnterPassword: 'Molimo Vas unesite Lozinku',
      lblRegisterEnterConfirmPassword: 'Lozinke se ne podudaraju',
      lblPriceList: 'Cenovnik',
      lblPriceListName: 'Naziv',
      lblPriceListPrice: 'Cena',
      lblGearForChildren: 'Oprema za decu',
      lblPriceListNumberOfDays: 'Broj dana',
      lblPriceListSet: 'Komplet',
      lblPriceListSki: 'Skije',
      lblPriceListShoes: 'Cipele',
      lblPriceListBoard: 'Daska',
      lblPriceListOtherGear: 'Ostala oprema',
      lblPriceListVipGear: 'Oprema VIP',
      lblGearForAdults: 'Oprema za odrasle',
      lblPayment: 'PLAĆANJE',
      lblProcess: 'OBRADA',
      lblPay: 'Plati',
      lblPaymentDetail: 'Uplata',
      lblStatus: 'Status',
      lblResListID: 'ID',
      lblResListUser: 'KORISNIK',
      lblResListFrom: 'OD',
      lblResListTo: 'DO',
      lblResListStatus: 'STATUS',
      lblResListDateCreated: 'DATUM KREIRANJA',
      lblResListAmount: 'IZNOS',
      lblResListPayed: 'PLAĆENO',
      lblResListPaymentId: 'ID PLAĆANJA',
      lblReservation: 'Rezervacija',
      lblBack: 'Nazad',
      lblStatusCreated: 'Kreiran',
      lblStatusProcessing: 'U obradi',
      lblStatusDone: 'Završen',
      lblStatusReversed: 'Storniran',
      lblResItemsName: 'IME',
      lblResItemsLastName: 'PREZIME',
      lblResItemsAge: 'GODINE',
      lblResItemsSport: 'SPORT',
      lblResItemsSkillLevel: 'NIVO',
      lblResItemsLessonType: 'TIP NASTAVE',
      lblResItemsNote: 'NAPOMENA',
      lblResItemsMeal: 'OBROK',
      lblResItemsGear: 'OPREMA',
      lblResItemsNumberOfDays: 'BR. ČASOVA DNEVNO',
      lblResItemsActions: 'AKCIJE',
      lblEdit: 'IZMENI',
      lblEditUser: 'Izmeni profil',
      lblSave: 'SAČUVAJ',
      lblSearch: 'Pretraga',
      lblUsernameExists: 'Korisničko ime već postoji',
      lblEmailExists: 'Email već postoji',
      lblPaymentSuccess: 'Uspešno ste izvršili plaćanje – račun Vaše platne kartice je zadužen',
      lblPaymentFinishReservationId: 'Rezervacija ID',
      lblPaymentFinishOrderId: 'Broj narudžbine',
      lblPaymentFinishAuthCode: 'Autorizacioni kod',
      lblPaymentFinishTransactionStatus: 'Status transakcije',
      lblPaymentFinishTransactionStatusCode: 'Kod statusa transakcije',
      lblPaymentFinishTransNo: 'Broj transakcije',
      lblPaymentFinishTransDate: 'Datum transakcije',
      lblPaymentFinishTranAmount: 'Iznos transakcije',
      lblPaymentFinishTranRefId: 'Ref. id transakcije',
      lblPaymentFail: 'Plaćanje neuspešno – račun Vaše platne kartice nije zadužen.',
      lblOk: 'OK',
      lblReservationConfirm: 'Potvrda rezervacije',
      lblPaymentInitTotalDays: 'ukupno',
      lblPaymentInitDays: 'dana',
      lblPaymentInitName: 'Naziv',
      lblPaymentInitQuantity: 'Količina',
      lblPaymentInitAmount: 'Iznos',
      lblPaymentInitTotal: 'UKUPNO',
      lblPaymentInitSelectPaymentOption: 'Izaberite način plaćanja',
      lblPaymentInitCreateReservation: 'Kreirajte rezervaciju!',
      // tslint:disable-next-line: max-line-length
      lblPaymentInitCreateReservationError: 'Greška pri kreiranju rezervacije. Molimo Vas pokusajte ponovo ili nas kontakirajte nas putem telefona ili email-a',
      msgReservationCreated: 'Zahtev će biti obrađen u najkraćem mogućem roku i bićete kontaktirani sa detaljima rezervacije!',
      // tslint:disable-next-line: max-line-length
      msgReservationCreatedContinueToPayment: 'Rezervacija je uspešno kreirana. Bićete kontaktirani sa detaljima rezervacije. Bićete preusmereni na stranicu za plaćanje',
      msgReservationCreatedTitle: 'Rezervacija uspešno kreirana',
      msgPaymentErrorTitle: 'Greška prilikom plaćanja',
      msgPaymentError: 'Došlo je do greške u komunikaciji sa servisom za plaćanje!',
      lblPaymentOptionOnRecive: 'PO PRIJEMU PREDRAČUNA U ROKU OD 48H',
      lblPaymentOptionPartOfAmount: 'PLATNOM KARTICOM ONLINE: AVANS- 30% OD VREDNOSTI USLUGE (ukupno',
      lblPaymentOptionFullAmount: 'PLATNOM KARTICOM ONLINE: PLAĆANJE 100% OD VREDNOSTI USLUGE (ukupno',
      lblPaymentLogo: 'Saznaj više',
      lblReservationAddInvalidData: 'Nepotpuni podaci',
      msgReservationAddMandatoryFieds: 'Niste popunili obavezna polja!',
      lblReservationAddCanNotDelete: 'Nije moguce obrisati',
      lblReservationAddRequestSent: 'Uspešno poslat zahtev',
      msgReservationAddRequestSent: 'Zahtev će biti obrađen u najkraćem mogućem roku i bićete kontaktirani sa detaljima rezervacije!',
      msgReservationAddInvalidAge: 'Neispravan podatak - broj godina',
      msgReservationAddInvalidAddItems: 'Morate napraviti rezervaciju',
      msgReservationAddInvalidTermsAndConditions: 'Morate prihvatiti uslove korišćenja',
      msgReservationAddInvalidPeriodForLessonType: 'Izabrani tip nastave traje od {1} do {2} dana. Molim vas prilagodite izabrani period',
      // tslint:disable-next-line: max-line-length
      msgReservationAddInvalidMixedLessonTypes: 'Nije moguće na istu rezervaciju dodati korisnike za individualnu nastavu i grupnu nastavu. Molimo Vas napravite odvojene rezervacije.',
      lblInvalidUsernameOrPassword: 'Neispravan username i/ili password',
      lblAccount: 'Nalog',
      msgAccountCreatedSuccessfully: 'Nalog uspešno kreiran! Ulogujte se da biste napravili rezervaciju!',
      lblCustomer: 'Kupac',
      lblMerchant: 'Trgovac',
      lblOrderDetails: 'Podaci o narudžbini',
      lblPaymentInitPrice: 'Cena',
      lblPaymentInitTax: 'Porez',
      lblTransactionDetails: 'Podaci o transakciji',
      msgPaymentFailed: 'Najčešći uzrok je pogrešno unet broj kartice, datum isteka ili sigurnosni kod. Pokušajte ponovo, a u slučaju uzastopnih grešaka pozovite vašu banku.',
      lblPricelistGear: 'Cenovnik opreme',
      lblEnterdUsers: 'Uneti korisnici',
      lblPravilaIntelektualneSvojine:'Prava intelektualne svojine',
      msgPravilaIntelektualneSvojine: `Pojam „web sajt“ u svrhu ovog pravnog obaveštenja, obuhvata sve web strane na web adresi http://www.skolaskijanja.rs/ (daljem tekstu: web sajt).
      Celokupan sadržaj web sajta bez obzira na formu izražavanja, uključujući, ali ne ograničavajući se samo na dizajnerska rešenja, tekstove, baze podataka, tabele, uporedne analize, fotografije, crteže, animacije, video i audio prezentacije, intelektualno je vlasništvo Agencije SNOW STARS TEAM, kao nosioca  prava i pod zaštitom je nacionalnog Zakona o autorskom i srodnim pravima i međunarodnih konvencija koje regulišu oblast autorskih prava.
      Osim navedenog korisničkog prava, zabranjena je svaka druga objava, prerada, izmena, prevod, dopuna, prodaja, nedostojno iskorišćavanje dela, distribuiranje i na drugi način suprotno zakonu korišćenje sadržaja web sajta, odnosno pridruživanje sadržaja, ili dela sadržaja drugom web sajtu.
      Vlasništvo autorskih prava je nad svim autorskim radovima, koji su na bilo kakav način uključeni u web sajt. Znak i logotip SNOW STARS TEAM-a (u punom obliku) zaštićeni su pravnim aktima.
      Sva prava su zadržana. Posetilac ili korisnik veb sajta koristi sadržaj na njemu isključivo za svoju sopstvenu potrebu, tj. nekomercijalna potreba. Svaki drugi oblik upotrebe sadržaja web sajta (kopiranje, distribucija, apliciranje uz drugo robno ime ili marku i slično) u komercijalne svrhe je zabranjena, osim ako to nije regulisano posebnim ugovorom.`,
      lblOgranicenjeUpotrebeInformacijaIMaterijala: 'Ograničenje upotrebe informacija i materijala',
      msgOgranicenjeUpotrebeInformacijaIMaterijala: `Informacije i materijale, koji se kao takvi prikazuju na web sajtu, korisnik ili posetilac veb sajta može preuzeti sa servera za svoju sopstvenu upotrebu (kućnu upotrebu), pri čemu ne sme doći do kršenja naznačenih autorskih prava, prava intelektualne svojine ili drugih prava o kojima postoji obaveštenje. Dozvoljeno je preuzimanje i štampanje informacija i materijala sa namenom pregleda i korištenja u nekomercijalne svrhe. Svako drugo kopiranje, distribucija, ponovno objavljivanje, promene informacija i materijala sa www.skolaskijanja.rs ili njihovo dalje slanje kao i širenje na bilo koji drugi način bez prethodne pismene dozvole ili posebnog ugovora je zabranjeno.
      SNOW STARS TEAM ne odgovara za oblik i sadržaj povezanih (linkovanih) web sajtova.`,
      lblOgranicenjeOdgovornosti: 'Ograničenje odgovornosti',
      msgOgranicenjeOdgovornosti: `SNOW STARS TEAM se trudi da su podaci na web sajtu pravilni i ažurni, tako da SNOW STARS TEAM, ni bilo koje drugo pravno ili fizičko lice koje je učestvovalo u izradi web sajta ili pri njegovoj obnovi, ne može biti odgovorno za eventualnu štetu ili izgubljenu dobit, koja bi kod korisnika web sajta nastala usled upotrebe web sajta ili nemogućnosti korišćenja navedenog.
      SNOW STARS TEAM omogućava samo pristup sadržaju web sajta, tako da ne može biti odgovorna za eventualnu štetu ili izgubljenu dobit koja bi nastala kod korisnika usled ometanja rada web sajta.
      SNOW STARS TEAM ima pravo da bez prethodnog obaveštenja promeni web sajt.`,
      lblSigurnostLicnihPodataka: 'Sigurnost ličnih podataka',
      msgSigurnostLicnihPodataka: `Podaci, koje SNOW STARS TEAM dobija na bilo koji način preko web sajta, namenjeni su za isključivu internu upotrebu i SNOW STARS TEAM ih štiti u skladu sa propisima koji regulišu zaštitu ličnih podataka i zakona o obligacionim odnosima.`,
      lblIzjavaOPoverljivostiPodataka: 'Izjava o poverljivosti podataka',
      msgIzjavaOPoverljivostiPodataka: `Svi podaci o korisnicima našeg sajta strogo se čuvaju i dostupni su samo zaposlenima i povezanim licima kojima su ti podaci nužni za obavljanje posla/ispunjenje ugovora.
      Svi zaposleni SNOW STARS TEAM odgovorni su za poštovanje načela zaštite privatnosti.
      Podatke koji se pristupom na internet stranicu automatski beleže, a nisu lični podaci (vrste pretraživača, broj poseta, vreme provedeno na stranicama i sl.) SNOW STARS TEAM ima pravo koristiti isključivo radi ocene posećenosti internet stranice i radi poboljšanja sadržaja i funkcionalnosti istog.

      Korisnik uvek treba da preispita politiku aplikacija treće strane ili web stranice kako bi bio siguran da ste upoznati sa načinima na koji oni koriste informacije koje delite sa trećom stranom.

      SNOW STARS TEAM ne garantuje da oni poštuju naša pravila. Takođe ukoliko koristite spoljni izvor za objavljivanje informacija na sajtu (kao što su mobilne aplikacije ili drugi sajt), trebalo bi da proverite podešavanja privatnosti za taj spoljni izvor.

      SNOW STARS TEAM se obavezuje da neće zloupotrebljavati lične podatke.
      Ličnim podacima smatraju se svi podaci kojima se utvrđuje identitet posetioca sajta (ime i prezime, adresa e-pošte, adresa stanovanja i sl.).`,
      lblPlacanje: 'Plaćanje',
      msgPlacanje: `Prilikom unošenja podataka o platnoj kartici, poverljive informacije se prenose putem javne mreže u zaštićenoj (kriptovanoj) formi upotrebnom SSL protokola i PKI sistema,
      kao trenutno najsavremenije kriptografske tehnologije. Sigurnost podataka prilikom kupovine garantuje procesor platnih kartica ChipCard a.d Beograd,
      pa se tako kompletan proces naplate obavlja na stranicama ChipCard-a. Niti jednog trenutka podaci o platnoj kartici nisu dostupni našem sistemu.`,
      msgValutaPlacanja: `Sva plaćanja biće izvršena u lokalnoj valuti Republike Srbije – dinar (RSD). Za informativni prikaz cena u drugim valutama koristi se kurs (možete staviti npr. srednji kurs Narodne Banke Srbije).
      Iznos za koji će biti zadužena Vaša platna kartica biće izražen u Vašoj lokalnoj valuti kroz konverziju u istu po kursu koji koriste kartičarske organizacije, a koji nama u trenutku transakcije ne može biti poznat.
      Kao rezultat ove konverzije postoji mogućnost neznatne razlike od originalne cene navedene na našem sajtu. Hvala Vam na razumevanju.`,
      msgPovracaj: `U slučaju vraćanja robe i povraćaja sredstava kupcu koji je prethodno platio nekom od platnih kartica, delimično ili u celosti, a bez obzira na razlog vraćanja,
      SNOW STARS TEAM je u obavezi da povraćaj vrši isključivo preko VISA, EC/MC i Maestro metoda plaćanja.`,
      lblPolitikaReklamacije: 'Politika reklamacije',
      msgPolitikaReklamacije: `Potrošač ima pravo da odustane od ugovora zaključenog na daljinu, odnosno od robe kupljene putem on-line porudžbine, potpisivanjem izjave o odustanku. Izjava o odustanku biće blagovremena ako je poslata u roku od 14 dana, (bez navođenja razloga I dodatnih troškova) od dana prijema robe.
      Trgovac je dužan da izvrši povraćaj uplata koje je primio od potrošača, u roku od 14 dana od dana kada je primio izjavu o odustanku od ugovora.
      Potrošač je dužan da vrati robu trgovcu bez odlaganja, a najkasnije u roku od 14 dana od dana kada je poslao izjavu o odustanku.
      Ako je trgovac omogućio potrošaču da elektronskim putem popuni i pošalje obrazac za odustanak, dužan je da ga o prijemu obrasca obavesti bez odlaganja u pisanoj formi.`,
      lblGeneralno: 'Generalno',
      msgGeneralno: `Za moguće sporove oko upotrebe web sajta nadležni su zakoni Republike Srbije. Eventualne sporove rešavaće stvarno nadležni sud u Beogradu.
      Za upotrebu web sajta korisnik potvrđuje, da je prihvatio prethodno opisane uslove i da se sa njima slaže.`,
      lblTaxIncluded: '*PDV je uključen u cenu',
      lblPaymentTryAgain: 'Pokušajte ponovo',
      lblContinueWithoutPayment: 'Nastavi bez plaćanja',
      lblCookiesDisabled: 'Molimo Vas omogućite kolačiće',
      lblPaymentAmountPayed: 'PLAĆENO',
      msgIzjavaOPoverljivostiPodataka2: `U ime Snow Stars Team-a obavezujemo se da ćemo čuvati privatnost svih naših kupaca. Prikupljamo samo neophodne, osnovne podatke o kupcima/korisnicima i podatke neophodne za poslovanje i informisanje korisnika u skladu sa dobrim poslovnim običajima i u cilju pružanja kvalititne usluge. Dajemo kupcima mogućnost izbora uključujući mogućnost odluke da li žele ili ne da se izbrišu sa mailing lista koje se koriste za marketinške kampanje. Svi podaci o korisnicima/kupcima se strogo čuvaju i dostupni su samo zaposlenima kojima su ti podaci nužni za obavljanje posla. Svi zaposleni SNOW STARS TEAM-a odgovorni su za poštovanje načela zaštite privatnosti”.`,
      lblRentEquipment: 'Iznajmljivanje ski opreme',
      lblHeight: 'Visina',
      lblWeight: 'Težina',
      lblPlace: 'Mesto boravka',
      lblChooseGroupType: 'Izaberite vrstu opreme:',
      lblChooseEquipmentType: 'Izaberite koju opremu želite:',
      lblRentEquipmentReservation: 'Oprema',
      lblLessonReservation: 'Časovi',
      lblGroupType: 'Vrsta opreme',
      lblSheduleReservedEquipment: 'Raspored rezervisane opreme',
      lblAll: 'Sve',
      lblStatusReserved: 'Rezervisan',
      msgReservationNumberOfIndividualReservations: 'Nije moguće na jednu rezervaciju staviti više od 3 individualne nastave sa istim brojem časova dnevno. Molimo Vas napravite još jednu rezervaciju.',
      lblUser: 'Korisnik',
      lblUserList: 'Lista korisnika',
      lblAddUser: 'Dodaj korisnika',
      lblPHONE: 'TELEFON',
      lblUSERROLE: 'TIP KORISNIKA',
      lblTaxNotIncluded: '*Snow Stars TIM nije obveznik PDV-a'
    }
  },
  en: {
    languange: 'en',
    values: {
      lblCreateReservation: 'Create reservation',
      lblProfile: 'Profile',
      lblReservations: 'Reservations',
      lblInstructors: 'Instructors',
      lblUsers: 'Users',
      lblShedule: 'Schedule',
      lblPriceListLessons: 'Pricelist ski lessons',
      lblPriceListGearRent: 'Pricelist ski rent',
      lblLogout: 'Logout',
      lblConfirm: 'Confirm',
      lblCancel: 'Cancel',
      lblCompany: 'Company',
      lblFieldOfWork: 'Field of work',
      lblAddress: 'Address',
      lblMatBr: 'MatBr',
      lblPib: 'Pib',
      lblWebAddress: 'Web address',
      lblContactNumer: 'Phone',
      lblContactEmail: 'Email',
      msgCreateReservation: 'Reservations will be processed as soon as possible and you will get confirmation response on your email',
      msgProfile: 'View and edit your contact information',
      btnCreateReseravtionTxt: 'Create',
      lblView: 'View',
      msgViewReservations: 'View and edit created reservations',
      msgViewInstructors: 'View and edit instructors',
      msgViewSchedule: 'View your schedule',
      lblFrom: 'From',
      lblTo: 'To',
      lblEnterNextUser: 'Enter next user',
      lblAcceptTermsAndConditions: 'I agree with',
      lblWithTermsAndConditions: 'Terms and Conditions',
      lblTermsAndConditions: 'Terms and Conditions',
      lblReserve: 'Reserve',
      lblEnterUser: 'Enter user',
      lblName: 'Name',
      lblLastName: 'Last name',
      lblAge: 'Age',
      lblSport: 'Sport',
      lblSki: 'Ski',
      lblSnowboard: 'Snowboard',
      lblSkillLevel: 'Skill level',
      lblSkillLevelBasic: 'Beginner',
      lblSkillLevelIntermediate: 'Intermediate',
      lblSkillLevelExpert: 'Expert',
      lblSnowboardSkillLevel: 'Snowboard skill level',
      msgChooseInstructor: 'Select instructor (Note: just for individual lessons)',
      // tslint:disable-next-line: max-line-length
      msgChooseInstructorNote: 'Note: If requested instructor is not available administrator will chose instructor',
      lblLessonType: 'Lesson type',
      lblInidivdual: 'Individual',
      lblGroup2: 'Group 2 lessons',
      lblGroup4: 'Group 4 lessons',
      lblDaily: 'Select number of lessons daily',
      lblGearAndMeal: 'Select if you want meal and/or ski gear',
      lblMeal: 'Meal',
      lblGear: 'Ski gear',
      lblDelete: 'Delete',
      lblLogin: 'Login',
      lblRegister: 'Register',
      lblUserName: 'Username',
      lblPassword: 'Password',
      lblEnterPassword: 'Please enter password',
      lblEnterUsername: 'Please enter username',
      lblPleaseLoginToContinue: 'Please login to continue',
      lblRegisterToContinue: 'Please register to continue',
      lblPhone: 'Phone',
      lblEmail: 'Email',
      lblConfirmPassword: 'Confirm password',
      lblUserRole: 'User role',
      lblRegisterEnterName: 'Please enter your name',
      lblRegisterEnterLastName: 'Please enter your last name',
      lblRegisterEnterEmail: 'Please enter your email',
      lblRegisterEnterPhone: 'Please enter your phone',
      lblRegisterEnterUserName: 'Please enter your username',
      lblRegisterEnterPassword: 'Please enter your password',
      lblRegisterEnterConfirmPassword: 'Passwords do not match',
      lblPriceList: 'Pricelist',
      lblPriceListName: 'Name',
      lblPriceListPrice: 'Price',
      lblGearForChildren: 'For children',
      lblPriceListNumberOfDays: 'Number of days',
      lblPriceListSet: 'Set',
      lblPriceListSki: 'Ski',
      lblPriceListShoes: 'Shoes',
      lblPriceListBoard: 'Board',
      lblPriceListOtherGear: 'Other gear',
      lblPriceListVipGear: 'VIP gear',
      lblGearForAdults: 'For adults',
      lblPayment: 'PAYMENT',
      lblProcess: 'PROCESS',
      lblPay: 'Pay',
      lblPaymentDetail: 'Payment detail',
      lblStatus: 'Status',
      lblResListID: 'ID',
      lblResListUser: 'USER',
      lblResListFrom: 'FROM',
      lblResListTo: 'TO',
      lblResListStatus: 'STATUS',
      lblResListDateCreated: 'DATE CREATED',
      lblResListAmount: 'AMOUNT',
      lblResListPayed: 'PAYED',
      lblResListPaymentId: 'PAYMENT ID',
      lblReservation: 'Reservation',
      lblBack: 'Back',
      lblStatusCreated: 'Created',
      lblStatusProcessing: 'Processing',
      lblStatusDone: 'Done',
      lblStatusReversed: 'Reversed',
      lblResItemsName: 'NAME',
      lblResItemsLastName: 'LAST NAME',
      lblResItemsAge: 'AGE',
      lblResItemsSport: 'SPORT',
      lblResItemsSkillLevel: 'SKILL LEVEL',
      lblResItemsLessonType: 'LESSON TYPE',
      lblResItemsNote: 'NOTE',
      lblResItemsMeal: 'MEAL',
      lblResItemsGear: 'GEAR',
      lblResItemsNumberOfDays: 'NUMBER OF LESSONS DAILY',
      lblResItemsActions: 'ACTIONS',
      lblEdit: 'EDIT',
      lblEditUser: 'Edit profile',
      lblSave: 'SAVE',
      lblSearch: 'Search',
      lblUsernameExists: 'Username exists',
      lblEmailExists: 'Email exists',
      lblPaymentSuccess: 'Payment successful - your account is charged for transaction amount',
      lblPaymentFinishReservationId: 'Reservation ID',
      lblPaymentFinishOrderId: 'Order ID',
      lblPaymentFinishAuthCode: 'Auth. code',
      lblPaymentFinishTransactionStatus: 'Transaction status',
      lblPaymentFinishTransactionStatusCode: 'Transaction status code',
      lblPaymentFinishTransNo: 'Transaction number',
      lblPaymentFinishTransDate: 'Transaction date',
      lblPaymentFinishTranAmount: 'Transaction amount',
      lblPaymentFinishTranRefId: 'Transaction ref. ID',
      lblPaymentFail: 'Payment failed – your account is not charged',
      lblOk: 'OK',
      lblReservationConfirm: 'Reservation confirmation',
      lblPaymentInitTotalDays: 'total',
      lblPaymentInitDays: 'days',
      lblPaymentInitName: 'Name',
      lblPaymentInitQuantity: 'Quantity',
      lblPaymentInitAmount: 'Amount',
      lblPaymentInitTotal: 'TOTAL',
      lblPaymentInitSelectPaymentOption: 'Select payment option',
      lblPaymentInitCreateReservation: 'Reservation is not created!',
      // tslint:disable-next-line: max-line-length
      lblPaymentInitCreateReservationError: 'Reservation failed! Please try again or contact on email/phone  ',
      msgReservationCreated: 'Request will be processed as soon as possible and you will be contacted with reservation details!',
      // tslint:disable-next-line: max-line-length
      msgReservationCreatedContinueToPayment: 'Request will be processed as soon as possible and you will be contacted with reservation details. You will be redirected to payment page',
      msgReservationCreatedTitle: 'Reservation created successfuly',
      msgPaymentErrorTitle: 'Payment error',
      msgPaymentError: 'Error in communication with payment server!',
      lblPaymentOptionOnRecive: 'ON RECEIVING INVOICE 48h',
      lblPaymentOptionPartOfAmount: 'CREDIT CARD PAYMENT: 30% OF AMOUNT (total',
      lblPaymentOptionFullAmount: 'CREDIT CARD PAYMENT: 100% OF AMOUNT (total',
      lblPaymentLogo: 'Explore',
      lblReservationAddInvalidData: 'Incomplete data',
      msgReservationAddMandatoryFieds: 'You must fill mandatory data',
      lblReservationAddCanNotDelete: 'Cannot delete',
      lblReservationAddRequestSent: 'Request sent successfully',
      msgReservationAddRequestSent: 'Request will be processed as soon as possible and you will be contacted with reservation details!',
      msgReservationAddInvalidAge: 'Please enter age',
      msgReservationAddInvalidAddItems: 'Please add users to reservation',
      msgReservationAddInvalidTermsAndConditions: 'Please read and accept Terms And Conditions',
      // tslint:disable-next-line: max-line-length
      msgReservationAddInvalidPeriodForLessonType: 'Selected lesson type lasts from {1} to {2} days. Please adjust selected period accordingly',
      // tslint:disable-next-line: max-line-length
      msgReservationAddInvalidMixedLessonTypes: 'You cannot add individual and group lesson types on same reservation. Please make separate reservations.',
      lblInvalidUsernameOrPassword: 'Invalid username or password',
      lblAccount: 'Account',
      msgAccountCreatedSuccessfully: 'Account created! Login to create reservation',
      lblCustomer: 'Customer',
      lblMerchant: 'Merchant',
      lblOrderDetails: 'Order details',
      lblPaymentInitPrice: 'Price',
      lblPaymentInitTax: 'Tax',
      lblTransactionDetails: 'Transaction details',
      msgPaymentFailed: 'The most common cause is a wrong card number, expiration date of the card, or wrong security code. Please try again, and in case of repeated mistakes, contact your bank',
      lblPricelistGear: 'Pricelist gear',
      lblEnterdUsers: 'Entered users',
      lblPravilaIntelektualneSvojine: 'Intellectual property rights',
      msgPravilaIntelektualneSvojine: `The term "web site" for the purposes of this legal notice, includes all web pages on the web address http://www.skolaskijanja.rs/ ((hereinafter referred to as "the Website")).
      The entire content of a website, regardless of form of expression, including but not limited to design solutions, texts, databases, tables, comparisons, photographs, drawings, animations, video and audio presentations, is the intellectual property of the SNOW STARS TEAM Agency, as the rightsholder and is protected by national law copyright and related rights and international conventions governing copyright.
      In addition to the aforementioned user rights, any other publication, modification, modification, translation, amendment, sale, unworthy exploitation of the part, distribution and otherwise contrary to the law, use of the content of the website, or the association of the content, or part of the content to another website is prohibited
      Copyright is the property of all copyrighted works, which are in any way incorporated into the Website. The SNOW STARS TEAM sign and logo (in full form) are protected by legal acts.
      All rights reserved. The visitor or user of the website uses the content on it solely for their own use, ie. non-commercial need. Any other form of use of the content of the Website (copying, distributing, applying for another trade name or brand, etc.) for commercial purposes is prohibited, unless regulated by a separate agreement.`,
      lblOgranicenjeUpotrebeInformacijaIMaterijala: 'Restriction on the use of information and materials',
      msgOgranicenjeUpotrebeInformacijaIMaterijala: `Information and materials displayed as such on the Website may be downloaded by the user or visitor from the server for their own use (home use), without infringing any copyrights, intellectual property rights or other rights about which there is a notice.
      It is allowed to download and print information and materials for the purpose of review and use for non-commercial purposes. Any other copying, distribution, republication, alteration of information and materials from www.skolaskijanje.rs or their further submission as well as distribution in any other way without prior written permission or special agreement is prohibited.
      SNOW STARS TEAM is not responsible for the form and content of linked (linked) websites.`,
      lblOgranicenjeOdgovornosti: 'Disclaimer',
      msgOgranicenjeOdgovornosti: `SNOW STARS TEAM strives that the information on the Website is correct and up-to-date, so that SNOW STARS TEAM, nor any other legal or natural person who participated in the creation of the website or in its restoration, can not be held responsible for any damage or lost profit that would result from the use of the website by the website users or the inability to use the above.
      SNOW STARS TEAM only allows access to the content of the website, so it cannot be held responsible for any damage or lost profits that may result from the user due to disruption of the website operation.
      SNOW STARS TEAM has the right to change the Website without notice.`,
      lblSigurnostLicnihPodataka: 'Security of personal information',
      msgSigurnostLicnihPodataka: `The information obtained by SNOW STARS TEAM in any way through the Website is intended for exclusive internal use only and is protected by SNOW STARS TEAM in accordance with the regulations governing the protection of personal data and the law on obligations.`,
      lblIzjavaOPoverljivostiPodataka: 'Data Privacy Statement',
      msgIzjavaOPoverljivostiPodataka: `
      All information about users of our site is strictly kept and is available only to employees and related parties who need this information to perform their work / fulfill the contract.
      All SNOW STARS TEAM employees are responsible for compliance with the privacy principles.
      SNOW STARS TEAM has the right to use the information that is automatically accessed on the website and is not personal data (types of search engines, number of visits, time spent on web pages, etc.) to improve the content and functionality of the website.

      The user should always review the policy of the third party application or website to make sure that you are aware of how they use the information you share with the third party.

      SNOW STARS TEAM does not guarantee that they comply with our rules. Also, if you are using an external source to post information to a site (such as a mobile application or other site), you should check the privacy settings for that external source.

      SNOW STARS TEAM agrees not to misuse personal information.
       Personal information is any information that identifies a site visitor (first and last name, email address, residence address, etc.).`,
      lblPlacanje: 'Payment',
      msgPlacanje: `When entering payment card information, confidential information is transmitted over a public network in a secure (encrypted) form using SSL protocols and PKI systems,
      as currently state-of-the-art cryptographic technology. Data protection at purchase is guaranteed by payment card processor ChipCard a.d Belgrade,
      so the complete billing process is done on the ChipCard site. At no time is payment card information available to our system.`,
      msgValutaPlacanja: `All payments will be made in the local currency of the Republic of Serbia - RSD (RSD). For informative presentation of prices in other currencies the exchange rate is used (you can put, for example, the middle exchange rate of the National Bank of Serbia).
      The amount your card will be charged for will be expressed in your local currency through conversion to the same rate used by the card organizations, which may not be known to us at the time of the transaction.
      As a result of this conversion there is a possibility of a slight difference from the original price listed on our site. Thank you for your understanding.`,
      msgPovracaj: `In the case of return of goods and refunds to a customer who has previously paid for any of the payment cards, in whole or in part, regardless of the reason for the refund,
      SNOW STARS TEAM is obliged to make a refund exclusively through VISA, EC / MC and Maestro payment methods.`,
      lblPolitikaReklamacije: 'Complaints policy',
      msgPolitikaReklamacije: `The consumer has the right to cancel the contract concluded at a distance, that is, the goods purchased by online order, by signing the statement of withdrawal. The waiver statement will be timely if it is sent within 14 days (without stating reasons and additional costs) from the date of receipt of the goods.
      The merchant is obliged to refund the payment received from the consumer within 14 days of receiving the statement of cancellation of the contract.
      The consumer is obliged to return the goods to the merchant without delay, and no later than 14 days from the date of dispatch of the withdrawal statement.
      If the retailer has enabled the consumer to electronically fill out and submit the withdrawal form, he shall notify the consumer without delay in writing without delay.`,
      lblGeneralno: 'Generally',
      msgGeneralno: `Possible disputes regarding the use of the website are the law of the Republic of Serbia. Possible disputes will be settled by the competent court in Belgrade.
      For the use of the website, the user confirms that he has accepted the above conditions and agrees with them.`,
      lblTaxIncluded: '*Tax is included in price',
      lblPaymentTryAgain: 'Try again',
      lblContinueWithoutPayment: 'Continue without payment',
      lblCookiesDisabled: "Cookies are disabled. Please turn them on and try again",
      lblPaymentAmountPayed: 'Amount payed:',
      msgIzjavaOPoverljivostiPodataka2: `On behalf of the Snow Stars Team, we commit ourselves to protect the privacy of all our customers. We only collect necessary, basic customer / customer information and data necessary for business and customer information in accordance with good business practices and in order to provide quality service. We give customers the choice, including the ability to decide whether or not to delete them from the mailing lists used for marketing campaigns. All customer/customer information is strictly kept and is only available to employees who need it to do the job. All employees (SNOW STARS TEAM) are responsible for respecting the principles of privacy.`,      
      lblRentEquipment: 'Ski equipment rental',
      lblHeight: 'Height',
      lblWeight: 'Weight',
      lblPlace: 'Place of residence',
      lblChooseGroupType: 'Select the type of equipment:',
      lblChooseEquipmentType: 'Choose which equipment you want:',
      lblRentEquipmentReservation: 'Equipment',
      lblLessonReservation: 'Lessons',
      lblGroupType: 'Type of equipment',
      lblSheduleReservedEquipment: 'Schedule of reserved equipment',
      lblAll: 'All',
      lblStatusReserved: 'Reserved',
      msgReservationNumberOfIndividualReservations: 'It is not possible to place more than 3 individual classes with the same number of lessons per day on a single reservation. Please make another reservation.',
      lblUser: 'User',
      lblUserList: 'List of users',
      lblAddUser: 'Add a user',
      lblPHONE: 'PHONE',
      lblUSERROLE: 'USER ROLE',
      lblTaxNotIncluded: '*Snow Stars TIM is not liable to VAT'
    }
  }
};
